import React, { useEffect, useState } from 'react';
import Layout from '../../components/global/layout';
import { Tooltip } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import SelectDropdown from '../../components/common/SelectDropdown';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { toast } from 'react-toastify';

const AddEditFaq = () => {
  const { id } = useParams();
  const history = useNavigate();
  const [form, setform] = useState({});
  const [Submitted, setSubmitted] = useState(false);
  const [category, setcategory] = useState('');
  useEffect(() => {
    getcategory();
    if (id) {
      ApiClient.get(`faq?id=${id}`).then((res) => {
        if (res?.success) {
          setform({
            question: res?.data?.question,
            answer: res?.data?.answer,
            category_id: res?.data?.category_id?.id,
          });
        }
      });
    }
  }, [id]);

  const getcategory = () => {
    ApiClient.get(`CommonCategory/all`, { type: 'faq' }).then((res) => {
      if (res?.success) {
        setcategory(res?.data.filter(itm=>itm?.status=="active"?itm?.name:''));
      } 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!form?.question || !form?.answer || !form?.category_id) {
      return;
    }
    let method = 'post';
    let url = 'faq';
    let value = {
      ...form,
    };
    if (id) {
      method = 'put';
      url = 'faq';
      value.id = JSON.parse(id);
    } else {
      // value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        toast.success(res?.message);
        setform({});
        history('/faq');
      }
      loader(false);
    });
  };

  const selectcategory = (e) => {
    setform({ ...form, category_id: e.value });
  };

  const back = () => {
    history(-1);
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        <div className="pprofile1 shadow-lg">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <button
                type="button"
                onClick={(e) => back()}
                className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </button>
            </Tooltip>
            <div>
              <h3 className="text-2xl font-semibold text-[#111827]">
                {id ? ' Edit ' : ' Add '}
                FAQ's
              </h3>
              <p class="text-sm font-normal text-[#525252]">
                Here you can add all about your FAQ's
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-4">
            <>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Category <span className="star">*</span>
                </label>
                <SelectDropdown
                  className={'capitalize'}
                  placeholder="Select Category"
                  options={category}
                  required={true}
                  intialValue={form?.category_id || ''}
                  result={selectcategory}
                />
                {Submitted && !form?.category_id ? (
                  <span className="star">Please select category </span>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-12">
                <label>
                  Question<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form.question}
                  onChange={(e) =>
                    setform({ ...form, question: e.target.value })
                  }
                  required
                />
                {Submitted && !form?.question ? (
                  <p className="text-[#ff000]">Question is required</p>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-12">
                <label>
                  Answer<span className="star">*</span>
                </label>
                <textarea
                  rows="4"
                  cols="50"
                  className="relative shadow-box bg-white w-full rounded-lg flex items-center gap-2 focus-visible:outline-0 px-2"
                  value={form.answer}
                  onChange={(e) => setform({ ...form, answer: e.target.value })}
                  required
                />
                {Submitted && !form?.answer ? (
                  <p className="text-[#ff000]">Answer is required</p>
                ) : (
                  <></>
                )}
              </div>
            </>
          </div>
          <div className="flex justify-end mt-2">
            <button
              type="submit"
              className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </Layout>
  );
};

export default AddEditFaq;
